import { EnumFeatureFlagName } from '@blank/api'
import { getSignupStaticProps } from 'modules/auth/lib/signup/getStaticProps'
import { EnumSignupType } from 'modules/auth/types/signup'
import { BetaVersionBannerMessage } from 'modules/common/components/BetaVersionBannerMessage/BetaVersionBannerMessage'
import { Seo } from 'modules/common/components/Seo/Seo'
import { COUNTRY_API_BASE_URL_MAP } from 'modules/common/http/apiClient'
import { useCountryConfig } from 'modules/common/hooks/useCountryConfig'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { SignupContainer } from 'modules/auth/components/SignupForm/SignupContainer'
import { fetchFeatureFlag } from 'modules/corporate/api/fetchFeatureFlag'
import { EnumUserLocale, USER_COUNTRY_MAP } from 'modules/common/types/locale'
import { BlankPage } from 'modules/common/types/page'
import { GetStaticProps } from 'next'

interface SignupPageProps {
  isOnboardingClosed: boolean
}

export const SignupPage: BlankPage<SignupPageProps> = ({
  isOnboardingClosed,
}) => {
  const { t } = useTranslation('auth-page-signup')

  const { isBeta } = useCountryConfig()

  return (
    <>
      <Seo
        title={t('meta.title')}
        description={t('meta.description')}
        noindex={isOnboardingClosed}
      />
      {isBeta && <BetaVersionBannerMessage />}
      <SignupContainer signupType={EnumSignupType.BANK} />
    </>
  )
}

export const getStaticProps: GetStaticProps<SignupPageProps> = async ({
  locale,
}) => {
  const country = USER_COUNTRY_MAP[locale as EnumUserLocale]
  const baseURL = COUNTRY_API_BASE_URL_MAP[country]

  let isOnboardingClosed = false
  try {
    const data = await fetchFeatureFlag({
      featureName: EnumFeatureFlagName.CLOSE_ONBOARDING,
      baseURL,
    })
    isOnboardingClosed = data?.body?.enabled === true
  } catch {
    // API failure → default to indexable (safe)
  }

  return {
    props: {
      ...(await getSignupStaticProps(locale as string)),
      isOnboardingClosed,
    },
    revalidate: 3600,
  }
}

SignupPage.type = 'notAuthenticated'
export default SignupPage
